import { AutoFocusInside } from "react-focus-on";
import { IconNames } from "../../../../Foundation/Icons";
import Button from "../../../Button";
import { ButtonTypes } from "../../../Button/interface";
import { ModalWithTitleAndCloseProps } from "../../interface";
import styles from "./modalWithTitleAndClose.module.scss";

const ModalWithTitleAndClose = ({
    children,
    title,
    backgroundColor,
    handleClose = () => null,
}: ModalWithTitleAndCloseProps) => {
    let styleObject = {};

    if (backgroundColor) {
        styleObject = {
            backgroundColor,
        };
    }

    return (
        <div className={styles.modalContent} style={styleObject}>
            <div className={styles.header}>
                <AutoFocusInside>
                    <h2 tabIndex={-1}>{title}</h2>
                </AutoFocusInside>
                <Button
                    type={ButtonTypes.IconButton}
                    label="Close"
                    name={IconNames.Close}
                    onClick={handleClose}
                    size="32"
                />
            </div>
            {children}
        </div>
    );
};
export default ModalWithTitleAndClose;
